export interface CmsContent {
  cmsTitle: string;
  cmsRoute: string;
}

export const CMS: Array<CmsContent> = [
  {
    cmsTitle: 'PrivacyPolicy',
    cmsRoute: '/support/privacy-policy'
  },
  {
    cmsTitle: 'Terms&Conditions',
    cmsRoute: '/support/terms-conditions'
  },
  {
    cmsTitle: 'MembershipTerms&Conditions',
    cmsRoute: '/support/membership-terms-conditions'
  },
  // {
  //   cmsTitle: 'MerchantPrivacyPolicy',
  //   cmsRoute: '/support/merchant-policy'
  // },
  {
    cmsTitle: 'FAQ',
    cmsRoute: '/support/faq'
  },
  {
    cmsTitle: 'CookiePolicy',
    cmsRoute: '/support/cookie-policy'
  },
  {
    cmsTitle: 'DeliveryPolicy',
    cmsRoute: '/support/delivery-policy'
  },
  {
    cmsTitle: 'PaymentConfirmation',
    cmsRoute: '/support/payment-confirmation'
  },
  {
    cmsTitle: 'RefundPolicy',
    cmsRoute: '/support/refund-policy'
  },
  {
    cmsTitle: 'DataDeletionPolicy',
    cmsRoute: '/support/dataDeletion-policy'
  },
  {
    cmsTitle: 'Concierge',
    cmsRoute: '/support/Concierge'
  },
  // {
  //   cmsTitle: 'MarketingServices',
  //   cmsRoute: '/support/Marketing-Services'
  // },
  {
    cmsTitle: 'WhyPartnerWithXploraLuxe',
    cmsRoute: '/support/Why-Partner'
  },
  // {
  //   cmsTitle: 'PremiumPlacement',
  //   cmsRoute: '/support/premium-placement'
  // }
];
